module.exports = __webpack_public_path__ + "img/test.c7042fcc.png";